import { Button } from '@p2p/components';
import { TGetOrderResponse } from '@p2p/services';
import { useScrollLock } from '@p2p/shared/hooks';
import { FC, useEffect, useState } from 'react';

import styles from './styles.module.scss';

type ModalBankTranferProps = {
  order: TGetOrderResponse;
};

const ID = `modal_bank_showed`;
const checkIsShowed = (id: string) => {
  const lastShowed = localStorage.getItem(ID);

  return !!lastShowed && lastShowed === id;
};

export const ModalBankTranfer: FC<ModalBankTranferProps> = ({ order }) => {
  const [isShowed, setIsShowed] = useState(checkIsShowed(order.id));
  useScrollLock(!isShowed);

  const onClose = () => {
    setIsShowed(true);
  };

  useEffect(() => {
    if (!isShowed) {
      localStorage.setItem(ID, order.id);
    }
  }, [isShowed, order.id]);

  if (isShowed) {
    return null;
  }

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <img src={order.bank_svg_image} alt={order.requisite.bank.name} className={styles.img} />
        <div className={styles.text_container}>
          <div className={styles.header}>
            <div className={styles.title}>Переведите на {order.requisite.bank.name}</div>
          </div>
          <div className={styles.details}>
            <div className={styles.detailsTitle}>
              При выборе другого банка
              <br />
              средства будут утеряны.
            </div>
          </div>
        </div>
        <div className={styles.buttons}>
          <Button onClick={onClose}>Хорошо</Button>
        </div>
      </div>
    </div>
  );
};
